import { Form, Input, Space } from 'antd'

import FeedUrlSourceAuthenticationBaseForm from './FeedAuthenticationBaseForm'

interface FeedUrlSourceAuthenticationApiKeyProps {
  isSubmitted?: boolean
  onSubmit: (credentials: { api_key: string }) => void
  initialValues?: { api_key: string }
}

function FeedUrlSourceAuthenticationApiKey({
  isSubmitted,
  onSubmit,
  initialValues,
}: FeedUrlSourceAuthenticationApiKeyProps): JSX.Element {
  const [apiKeyForm] = Form.useForm()

  return (
    <FeedUrlSourceAuthenticationBaseForm
      form={apiKeyForm}
      isSubmitted={isSubmitted}
      shouldValidate={false}
      onSubmit={onSubmit}
      {...(initialValues
        ? {
            initialValues: {
              api_key: initialValues.api_key,
            },
          }
        : {})}
    >
      <Space.Compact block className="mb-12">
        <Form.Item
          label="API Key"
          className="[&>div>.ant-form-item-label]:!pb-0 [&>div>.ant-form-item-label>label]:text-gray-700 [&>div>.ant-form-item-label>label]:font-medium [&>div>.ant-form-item-label]:mb-0 [&>div>.ant-form-item-label]:text-sm mb-0 flex-1 [&>div>div>.ant-form-item-additional]:absolute [&>div>div>.ant-form-item-additional]:text-error-700"
          htmlFor="api_key"
          name="api_key"
        >
          <Input.Password
            placeholder="Enter API Key"
            name={Math.random().toString(36)}
            visibilityToggle
            className="flex h-[40px] justify-between border rounded-lg w-full !p-0 !pr-2 [&>input]:!p-2.5 [&>input]:!leading-none [&>input]:text-[100%] text-gray-900 bg-white-100 !border-gray-300 [&.ant-input-status-error]:!border-error-300"
            autoComplete="off"
          />
        </Form.Item>
      </Space.Compact>
    </FeedUrlSourceAuthenticationBaseForm>
  )
}

export default FeedUrlSourceAuthenticationApiKey
